<template>
    <v-snackbar
            id="snackbar"
            v-model="show"
            :color="color"
            :timeout="timeout"
    >
        {{message}}
        <v-btn
                color="primary"
                text
                @click="show = false"
                v-if="color === 'error'"
        >
            Schließen
        </v-btn>
    </v-snackbar>
</template>

<script lang="ts">
    import {Component, Watch, Vue} from 'vue-property-decorator';

    @Component
    export default class TheSnackbar extends Vue {

        static defaultTimeout:number = 5000

        show: boolean = false
        timeout: number = TheSnackbar.defaultTimeout
        message: string = ''
        color: string = 'info'

        @Watch('$store.state.snackbar.message')
        setMessage() {
            this.show = true
            this.message = this.$store.state.snackbar.message
        }

        @Watch('$store.state.snackbar.level')
        setColor() {
            this.color = this.$store.state.snackbar.level
            if(this.color === 'error') {
                this.timeout = 0
            } else {
                this.timeout = TheSnackbar.defaultTimeout
            }
        }
    }
</script>

